import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { CommandFactoryService } from '../../../core/service/factory/command-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
// import { rentalObjectCommand, tenantCommand } from '../../model/const/command';
import { Contact } from '../../model/contact';
import { OtherRentalObject } from '../../model/other-rental-object';
import { Property } from '../../model/property';
import { RentalObject } from '../../model/rental-object';
import { RentalObjectType } from '../../model/rental-object-type';
import { OtherRentalObjectCommandFactory } from '../../service/command/factory/other-rental-object-command-factory.service';
import { OtherRentalObjectCommandHandlerResolver } from '../../service/command/other-rental-object-command-handler-resolver.service';
import { PrintGdprCommandHandler } from '../../service/command/print-gdpr-command-handler.service';
import { SendRegistrationKeyCommandHandler } from '../../service/command/send-registration-key-command-handler.service';
import { TenantCommandHandlerResolver } from '../../service/command/tenant-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { ObjectManagerComponentBase } from './../../../core/component/object-manager/object-manager.base';
import { Company } from './../../model/company';
import { CompanyService } from './../../service/data/company.service';
import { OtherRentalObjectService } from './../../service/data/other-rental-object.service';
import { PremisesService } from './../../service/data/premises.service';
import { RentalObjectTypeService } from './../../service/data/rental-object-type.service';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { companyCommand } from '../../command/company.command';
import { OtherRentalObjectExportCommandHandler } from '../../service/command/other-rental-object-export-command-handler.service';
import { standardCommand } from './../../../core/model/command';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../service/data/property.service';
import { CustomPropertyService } from '../../service/data/custom-property.service';
import { CustomPropertyVisibilityType, FormOfLease, FormOfLeaseToString } from '../../model/const/enums';
import { CustomPropertyHelper } from '../../helper/customproperties-helper';
import { LettingFeatureFilterHelper } from '../../helper/letting-feature-filter-helper';
import { LettingFeatureColumnHelper } from '../../helper/letting-feature-column-helper';
import { LettingFeatureService } from '../../service/data/letting-feature.service';
import { forkJoin } from 'rxjs';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { UserAccountService } from '../../../common/service/user-account.service';
import { Features, ModuleNames } from '../../../common/model/account-definition';

@Component({
    selector: 'app-other-object-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [
        OtherRentalObjectCommandHandlerResolver,
        OtherRentalObjectExportCommandHandler,
        { provide: CommandFactoryService, useClass: OtherRentalObjectCommandFactory },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OtherRentalObjectManagerComponent extends PagedObjectManagerComponent<OtherRentalObject> {
  menuDefinition: MenuItemDefinition[];
  constructor(
    private _activatedRoute: ActivatedRoute,
    private readonly cdf: ColumnDefinitionFactory,
    columnDefinitionService: ColumnDefinitionService,
    dispatcher: CommandDispatcher,
    handlerResolver: OtherRentalObjectCommandHandlerResolver,
    private _propertyService: PropertyService,
    private _companyService: CompanyService,
    private _dataService: OtherRentalObjectService,
    messageService: MessageService,
    navigationService: NavigationService,
    private readonly _accountService: UserAccountService,
    private readonly _customPropertyService: CustomPropertyService,
    private readonly _ch: CustomPropertyHelper,
    private readonly _lettingFeatureService: LettingFeatureService,
    private readonly _lettingFeatureFilterHelper: LettingFeatureFilterHelper,
    private readonly _lettingFeatureColumnHelper: LettingFeatureColumnHelper
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.getRentalObjectOtherColumnDefinition(this);
    this.title = 'DASHBOARD.MENU.OTHER_RENTAL_OBJECT';
    this.preferencesKey = 'rent.other-rental-object.list';
    this.columnDefinition.push(this.cdf.createTranslation('RENTAL_OBJECT.FORM_OF_LEASE', 'formOfLeaseText', ColumnVisibility.optional));

    this.menuDefinition = [new MenuItemDefinition('LEASE_AGREEMENT.COMMAND.EXPORT', rentalObjectCommand.export)];

    this.AddSubscription(
      this._accountService.current.subscribe({
        next: account => {
          if (account.hasAccess(ModuleNames.Properties, Features.EditOtherRentalObject)) {
            this.allowNew = true;
          } else {
            this.allowNew = false;
          }
          if (account.hasAccess(ModuleNames.Properties, Features.ChangeRentalObjectCategory)) {
            this.addContextMenuItemDefinition('RENTAL_OBJECT_CATEGORY.COMMAND', rentalObjectCommand.changeCategory);
          }
        },
      })
    );

    this.addMenuItemDefinition('LEASE_AGREEMENT.COMMAND.RENTAL_CHANGE', rentalObjectCommand.feeChange);
  }

  protected addContextMenuItemDefinition(caption: string, commandId: string) {
    if (commandId === standardCommand.delete) {
      return;
    }
    super.addContextMenuItemDefinition(caption, commandId);
  }
  override filterInternal(filterState: any): void {
    this._ch.applyCustomPropertyFilters(filterState);
    this._lettingFeatureFilterHelper.applyLettingFeatureFilters(filterState);
  }
  ngOnInit() {
    this.AddSubscription(
      forkJoin([this._customPropertyService.getList(), this._dataService.getFilterDefinition(), this._lettingFeatureService.getAvailableForRentalObjects()]).subscribe(
        ([customProperties, definition, lettingFeatures]) => {
          this.defaultFilters = definition.defaultFields;
          const articles = definition.articles.map(article => {
            return { caption: article.toString(), value: article.id };
          });
          articles.splice(0, 0, { caption: 'ALL_TEXT', value: '' });

          var formOfLeaseSelection = [
            { caption: 'ALL_TEXT', value: null },
            { caption: FormOfLeaseToString(FormOfLease.Lease), value: FormOfLease.Lease },
            { caption: FormOfLeaseToString(FormOfLease.CooperativeHousing), value: FormOfLease.CooperativeHousing },
            { caption: FormOfLeaseToString(FormOfLease.Ownership), value: FormOfLease.Ownership },
          ];

          const selectedCompanies = definition.companyIds
            ? Array.isArray(definition.companyIds)
              ? definition.companyIds
              : [definition.companyIds]
            : [];

          const selectedProperties = definition.propertyIds
            ? Array.isArray(definition.propertyIds)
              ? definition.propertyIds
              : [definition.propertyIds]
            : [];

          this.filterDefinition = [
            new FilterDefinitionItem(
              'COMPANY.LIST_HEADER',
              'companyIds',
              selectedCompanies,
              this._companyService,
              definition.selectedFields.includes('companyIds') || definition.selectedFields.includes('company'),
              true
            ),
            new FilterDefinitionItem(
              'RENTAL_OBJECT_FORM.PROPERTY_LABEL',
              'propertyIds',
              selectedProperties,
              this._propertyService,
              definition.selectedFields.includes('propertyIds') || definition.selectedFields.includes('property'),
              true
            ),
            new FilterDefinitionItem(
              'RENTAL_OBJECT_FORM.RENTAL_OBJECT_NUMBER_LABEL',
              'rentalId',
              definition.rentalId,
              null,
              definition.selectedFields.includes('rentalId')
            ),
            new FilterDefinitionItem(
              'RENTAL_OBJECT_LIST.STREET_COLUMN',
              'street',
              definition.street,
              null,
              definition.selectedFields.includes('street')
            ),
            new FilterDefinitionItem(
              'ARTICLE.EDIT_HEADER',
              'article',
              definition.article,
              articles,
              definition.selectedFields.includes('article')
            ),
            new FilterDefinitionItem(
              'RENTAL_OBJECT.FORM_OF_LEASE',
              'formOfLease',
              definition.formOfLease,
              formOfLeaseSelection,
              definition.selectedFields.includes('formOfLease')
            ),
          ];

          const customPropertiesFilters = this._ch.generateCustomPropertyFilters(
            customProperties,
            definition,
            CustomPropertyVisibilityType.Company | CustomPropertyVisibilityType.Property
          );
          this._ch.createCustomPropertyColumnDefinition(
            customProperties,
            this.columnDefinition,
            CustomPropertyVisibilityType.Company | CustomPropertyVisibilityType.Property
          );
          this._lettingFeatureColumnHelper.createLettingFeatureColumnDefinitions(lettingFeatures, this.columnDefinition);
          const lettingFeatureFilters = this._lettingFeatureFilterHelper.generateLettingFeatureFilters(lettingFeatures, definition);
          this.filterDefinition = [...this.filterDefinition, ...customPropertiesFilters, ...lettingFeatureFilters];
        }
      )
    );

    this.addEditDeleteCommands();
  }
}
